import { render, staticRenderFns } from "./Landlords.vue?vue&type=template&id=cdfed818"
import script from "./Landlords.vue?vue&type=script&lang=js"
export * from "./Landlords.vue?vue&type=script&lang=js"
import style0 from "./Landlords.vue?vue&type=style&index=0&id=cdfed818&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports